<template>
  <v-card class="pa-4 d-flex flex-column" :class="{ 'error-scroller': unitError }" style="height: 100%">
    <div class="mb-4">
      <p class="title mb-1">Lojas participantes</p>
      <span class="subtitle">As lojas participantes são utilizada no cálculo de métricas e não afetam o disparo da campanha.</span>
    </div>
    <div class="mt-auto d-flex">
      <mf-select-units-dialog
        id="sms-campaign-units"
        class="d-flex justify-self-start"
        outlined
        :disabled="disabled"
        :selected-units.sync="localSelectedUnits"
        :unit-error="unitError"
        :units="units"
        :tag-list="tagList"
        :group-list="unitsGroups"
        dense
        hide-ecommerce-configuration
      />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UnitsConfiguration',
  props: {
    selectedUnits: {
      type: Array,
      default: () => [],
    },
    unitError: Boolean,
    disabled: Boolean,
  },
  emits: ['update:selectedUnits'],
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    localSelectedUnits: {
      get() {
        return this.selectedUnits
      },
      set(value) {
        this.$emit('update:selectedUnits', value)
      },
    },
    infoCardHtml() {
      return '<span style="color: #004D99">As lojas participantes são utilizada no cálculo de métricas e não afetam o disparo da campanha.</span>'
    },
  },
}
</script>
